import React, { useContext, useEffect } from 'react';

import PropTypes from 'prop-types';
import {
  OnboardingContext,
  OnboardingText,
  OnboardingTitle,
  OnboardingWrapper,
  ProgressStepsWrapper,
  sendUpdate,
} from 'registration/containers/Onboarding';

import { Center } from 'shared/components/ihcl/positioning';
import { ProgressSteps } from 'shared/components/ihcl/progress_steps';
import { styled } from 'shared/components/ihcl/styled';
import { Button } from 'shared/components/ihcl/v2/button';
import { toast } from 'shared/components/ihcl/v2/toast';
import { doPost } from 'shared/helpers/http';

const ExtraLargeTitle = styled('div', {
  fontSize: '48px',
  marginBottom: '8px',
});

const ReactivationCompleted = ({ currentStep, nextAction, totalSteps }) => {
  const {
    history,
    onboardingBasePath,
    onboardingData,
    onboardingUpdates,
    setOnboardingData,
  } = useContext(OnboardingContext);
  const { first_name: firstName } = onboardingData;

  useEffect(() => {
    doPost('/talent_reactivation/complete').catch((error) => {
      console.error(error);
      const errorMsg =
        'Oops, there was a problem connecting ' +
        'to the server. Please check your internet connection ' +
        'and refresh the page.';
      toast.error(errorMsg);
    });
  }, []);

  return (
    <Center>
      <OnboardingWrapper>
        {totalSteps > 0 && (
          <ProgressStepsWrapper>
            <ProgressSteps currentStep={currentStep} totalSteps={totalSteps} />
          </ProgressStepsWrapper>
        )}
        <OnboardingTitle style={{ marginTop: '40px' }}>
          <ExtraLargeTitle>🎉</ExtraLargeTitle>
          Thanks <span className="sentry-mask">{firstName}</span>, your profile
          is activated!
        </OnboardingTitle>
        <OnboardingText>
          You can also update the rest of your profile. Accurate profile =
          better opportunities!
        </OnboardingText>
        <div>
          <Button
            color="alternate"
            onClick={() => {
              window.mixpanel.track('Reactivation form completed');
              sendUpdate({
                currentStep,
                history,
                nextAction,
                onboardingBasePath,
                onboardingData,
                onboardingUpdates,
                setOnboardingData,
                stepName: 'Reactivation completed',
              });
            }}
          >
            Got it
          </Button>
        </div>
      </OnboardingWrapper>
    </Center>
  );
};
ReactivationCompleted.propTypes = {
  currentStep: PropTypes.number.isRequired,
  nextAction: PropTypes.string.isRequired,
  totalSteps: PropTypes.number.isRequired,
};

export default ReactivationCompleted;
